import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Modal, Form } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'

import * as UsuarioService from 'services/usuario.service'

const validationSchema = Yup.object().shape({
  tipoFirma: Yup.string().required()
})

const AsignarFirmaModal = ({ show, handleClose, actualizarTabla, username }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      file: '',
      tipoFirma: ''
    }
  }, [])

  const parsearYEnviarFormulario = React.useCallback(
    (data, { setSubmitting }) => {
      if (!data.file) {
        __zariContext.snack('error', 'Seleccionar archivo.')
        return
      }

      if (data.file.type !== 'image/jpeg') {
        __zariContext.snack('error', 'Solo se admiten documentos de extension jpg/jpeg.')
        return
      }

      const submitData = new FormData()
      submitData.append('file', data.file)
      submitData.append('tipoFirma', data.tipoFirma)

      __zariContext.loader.open('Subiendo firma...')
      UsuarioService.nuevaFirmaxIdUsuario(username, submitData)
        .then(() => {
          __zariContext.toast('success', 'Se ha importado la firma.')
          actualizarTabla()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
          handleClose()
        })
    },
    [__zariContext, handleClose, actualizarTabla, username]
  )

  const submitHandler = React.useCallback(
    async (data, { setSubmitting }) => {
      parsearYEnviarFormulario(data, { setSubmitting })
    },
    [parsearYEnviarFormulario]
  )

  return (
    <Modal show={show} size='smvalue={x.id}'>
      <Modal.Header>
        <Modal.Title>ASIGNAR FIRMA</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={validationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <FormGroups.FileFormGroup fIsSubmitting={isSubmitting} setFieldValue={setFieldValue} iError={errors.file} iTouched={touched.file} />
              <FormGroups.TipoFirmaFormGroup fIsSubmitting={isSubmitting} iError={errors.tipoFirma} iTouched={touched.tipoFirma} />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose} color='secondary' outline tiny disabled={isSubmitting}>
                Cerrar
              </Button>
              <Button onClick={handleSubmit} tiny disabled={isSubmitting}>
                Importar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(AsignarFirmaModal)
